import React from 'react'
import { findTarget } from '../../../../../utils/microcopy.utils'
import { renderRichText } from '../../../../../utils/richTextHandler.utils'
import Modal from '../../../../global/modal'
import Typography from '../../../../global/typography'
import WrapperImage from '../../../../global/wrapperImage'
import {
  LeadershipModalContent,
  LeadershipModalFooter,
  LeadershipModalHolder,
  LeadershipModalImage,
  LinkItem,
  RowContent,
} from './style'

const LeadershipModal = (props: any) => {
  const { open, onClose, data, contentType = null } = props

  const { fullName, role, miniBio, twitterProfile, linkedInProfile, image, microcopy } = data

  const handleClose = () => onClose()

  return (
    <Modal
      modalTitle="Standard Modal"
      modalDescription="UiPath Leadership Modal"
      innerClasses="LeadershipBioModal"
      handleClose={handleClose}
      open={open}
      dotted={true}
      contentType={contentType}>
      <LeadershipModalHolder data-cy="LeadershipModalHolder" contentType={contentType}>
        {image && (
          <LeadershipModalImage data-cy="LeadershipModalImage">
            <WrapperImage src={image} />
          </LeadershipModalImage>
        )}
        <LeadershipModalContent>
          {fullName && (
            <RowContent className="Content-FullName">
              <Typography type="header3">{fullName}</Typography>
            </RowContent>
          )}
          {role && (
            <RowContent className="Content-Role">
              <Typography type="bodyXS">{role}</Typography>
            </RowContent>
          )}
          {miniBio && (
            <RowContent className="Content-MiniBio">{renderRichText(miniBio)}</RowContent>
          )}
          <LeadershipModalFooter>
            {twitterProfile && microcopy && microcopy.values && (
              <a className="Content-LinkProfile" href={twitterProfile} target="_blank">
                <LinkItem className="BioCardFooter-TwitterProfile" />
                <Typography className="BioCardFooter-ProfileType" type="bodyXS">
                  {findTarget(`Twitter.text`, microcopy.values, false) || 'Twitter'}
                </Typography>
              </a>
            )}
            {linkedInProfile && microcopy && microcopy.values && (
              <a className="Content-LinkProfile" href={linkedInProfile} target="_blank">
                <LinkItem className="BioCardFooter-LinkedInProfile" />
                <Typography className="BioCardFooter-ProfileType" type="bodyXS">
                  {findTarget(`Linkedin.text`, microcopy.values, false) || 'LinkedIn'}
                </Typography>
              </a>
            )}
          </LeadershipModalFooter>
        </LeadershipModalContent>
      </LeadershipModalHolder>
    </Modal>
  )
}

export default LeadershipModal
